/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "кичә",
        "0": "бүген",
        "1": "иртәгә",
        "future": {
          "other": "{0} көннән"
        },
        "past": {
          "other": "{0} көн элек"
        }
      },
      "day-narrow": {
        "-1": "кичә",
        "0": "бүген",
        "1": "иртәгә",
        "future": {
          "other": "{0} көннән"
        },
        "past": {
          "other": "{0} көн элек"
        }
      },
      "day-short": {
        "-1": "кичә",
        "0": "бүген",
        "1": "иртәгә",
        "future": {
          "other": "{0} көннән"
        },
        "past": {
          "other": "{0} көн элек"
        }
      },
      "hour": {
        "0": "бу сәгатьтә",
        "future": {
          "other": "{0} сәгатьтән"
        },
        "past": {
          "other": "{0} сәгать элек"
        }
      },
      "hour-narrow": {
        "0": "бу сәгатьтә",
        "future": {
          "other": "{0} сәг."
        },
        "past": {
          "other": "{0} сәг. элек"
        }
      },
      "hour-short": {
        "0": "бу сәгатьтә",
        "future": {
          "other": "{0} сәг."
        },
        "past": {
          "other": "{0} сәг. элек"
        }
      },
      "minute": {
        "0": "бу минутта",
        "future": {
          "other": "{0} минуттан"
        },
        "past": {
          "other": "{0} минут элек"
        }
      },
      "minute-narrow": {
        "0": "бу минутта",
        "future": {
          "other": "{0} мин."
        },
        "past": {
          "other": "{0} мин. элек"
        }
      },
      "minute-short": {
        "0": "бу минутта",
        "future": {
          "other": "{0} мин."
        },
        "past": {
          "other": "{0} мин. элек"
        }
      },
      "month": {
        "-1": "узган айда",
        "0": "бу айда",
        "1": "киләсе айда",
        "future": {
          "other": "{0} айдан"
        },
        "past": {
          "other": "{0} ай элек"
        }
      },
      "month-narrow": {
        "-1": "узган айда",
        "0": "бу айда",
        "1": "киләсе айда",
        "future": {
          "other": "{0} айдан"
        },
        "past": {
          "other": "{0} ай элек"
        }
      },
      "month-short": {
        "-1": "узган айда",
        "0": "бу айда",
        "1": "киләсе айда",
        "future": {
          "other": "{0} айдан"
        },
        "past": {
          "other": "{0} ай элек"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "узган кварталда",
        "0": "бу кварталда",
        "1": "киләсе кварталда",
        "future": {
          "other": "{0} кварталдан"
        },
        "past": {
          "other": "{0} квартал элек"
        }
      },
      "quarter-narrow": {
        "-1": "узган кварталда",
        "0": "бу кварталда",
        "1": "киләсе кварталда",
        "future": {
          "other": "{0} кв."
        },
        "past": {
          "other": "{0} кв. элек"
        }
      },
      "quarter-short": {
        "-1": "узган кварталда",
        "0": "бу кварталда",
        "1": "киләсе кварталда",
        "future": {
          "other": "{0} кв."
        },
        "past": {
          "other": "{0} кв. элек"
        }
      },
      "second": {
        "0": "хәзер",
        "future": {
          "other": "{0} секундтан"
        },
        "past": {
          "other": "{0} секунд элек"
        }
      },
      "second-narrow": {
        "0": "хәзер",
        "future": {
          "other": "{0} с."
        },
        "past": {
          "other": "{0} с. элек"
        }
      },
      "second-short": {
        "0": "хәзер",
        "future": {
          "other": "{0} с."
        },
        "past": {
          "other": "{0} с. элек"
        }
      },
      "week": {
        "-1": "узган атнада",
        "0": "бу атнада",
        "1": "киләсе атнада",
        "future": {
          "other": "{0} атнадан"
        },
        "past": {
          "other": "{0} атна элек"
        }
      },
      "week-narrow": {
        "-1": "узган атнада",
        "0": "бу атнада",
        "1": "киләсе атнада",
        "future": {
          "other": "{0} атнадан"
        },
        "past": {
          "other": "{0} атна элек"
        }
      },
      "week-short": {
        "-1": "узган атнада",
        "0": "бу атнада",
        "1": "киләсе атнада",
        "future": {
          "other": "{0} атнадан"
        },
        "past": {
          "other": "{0} атна элек"
        }
      },
      "year": {
        "-1": "узган ел",
        "0": "быел",
        "1": "киләсе елда",
        "future": {
          "other": "{0} елдан"
        },
        "past": {
          "other": "{0} ел элек"
        }
      },
      "year-narrow": {
        "-1": "узган ел",
        "0": "быел",
        "1": "киләсе елда",
        "future": {
          "other": "{0} елдан"
        },
        "past": {
          "other": "{0} ел элек"
        }
      },
      "year-short": {
        "-1": "узган ел",
        "0": "быел",
        "1": "киләсе елда",
        "future": {
          "other": "{0} елдан"
        },
        "past": {
          "other": "{0} ел элек"
        }
      }
    },
    "locale": "tt"
  });
}